<button
    type="button"
    class="cerrix-icon-btn"
    [class.bordered]="showBorder"
    [class.small]="buttonSize === 'small'"
    [disabled]="disabled"
    [attr.aria-label]="ariaLabel"
>
    <mat-icon [svgIcon]="icon" />
</button>
